<!-- Component for rendering a list item 'slide' with one big image -->
<template>
	<SbImage
		:blok="slide.content?.filename ? slide.content : slide.image"
		class="h-full max-h-dvh w-full object-cover"
		alt="Slide image"
	/>
</template>

<script setup lang="ts">
import SbImage from '@/components/blocks/SbImage.vue'
import type { ListItemImageSlideStoryblok } from '@/sbTypes'

defineProps<{ slide: ListItemImageSlideStoryblok }>()
</script>
